import { render } from "./HotelPlaceOrder.vue?vue&type=template&id=3b3e6053&scoped=true"
import script from "./HotelPlaceOrder.vue?vue&type=script&lang=js"
export * from "./HotelPlaceOrder.vue?vue&type=script&lang=js"

import "./HotelPlaceOrder.vue?vue&type=style&index=0&id=3b3e6053&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3e6053"]])

export default __exports__